export default __webpack_public_path__ + "static/media/Daniel_rounded.5faf17c0.png";